/**
 * @ignore
 * User: daletan
 * Date: 1/15/16
 * Time: 5:56 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */

'use strict';

const {trackEmailFriend} = require('./pdpTrackingActions');
const ModalEmail = require('../../global/modules/modalEmail/ModalEmailBase');
const contactDealerLauncher = require('../../contact/dealer/helpers/contactDealerLauncher');
const netPriceLauncher = require('../../contact/netPrice/helpers/netPriceLauncher');
const bunsenAssert = require('bunsen/helpers/assert');
const dibsVerticals = require('dibs-vertical-helpers');
const PurchaseTracking = require('../../global/mixins/purchaseTracking');

const launchModalEmail = (payload = {}) => {
    // TODO: Currently, if we cache the modal instead of re-creating it each time, the modal will not work after
    // the first open. This modal should ultimately be refactored to fix this issue and then we can re-use it here.
    const emailModal = new ModalEmail({
        type: 'friend',
        pageType: 'item'
    });
    bunsenAssert(payload.id && payload.vertical, 'both payload.id and payload.vertical are required');
    emailModal.show(payload);
};

const launchContactDealer = (actionContext, payload) => {
    const { itemPk,
            dealerPk,
            currentStep,
            handleCtaClick,
            tracking: linkLocation,
            modalContentData } = payload;
    contactDealerLauncher({
        context: actionContext,
        itemPk,
        linkLocation,
        dealerPk,
        currentStep,
        handleCtaClick,
        modalContentData
    });
};

const trackNetPriceClick = (purchaseTracking) => {
    if (purchaseTracking) {
        purchaseTracking.trackNetPriceEvent({
            actionSuffix: 'clicked-amppage'
        });
    }
};

const launchRequestNetPrice = (actionContext, payload) => {
    const { item,
            itemPk,
            currency,
            tracking: linkLocation } = payload;
    const purchaseTracking = new PurchaseTracking({ item, pageContext: linkLocation.pageContext });
    trackNetPriceClick(purchaseTracking);
    netPriceLauncher({
        context: actionContext,
        itemPk,
        purchaseTracking: purchaseTracking,
        linkLocation,
        item,
        currency
    });
};

// need to keep this variable reference
// otherwise Fluxible context will see `this` this as undefined
const modals = module.exports = {
    stf(actionContext, payload, done) {
        // calling "private" property so can be spied on in tests
        const { id, vertical, itemPk } = payload;
        let realFuckingId = id;
        if (dibsVerticals.testForPk(id)) {
            // fucking pk/id strikes again!
            realFuckingId = id.substring(2);
        }
        modals._stf({ id: realFuckingId, vertical });
        actionContext.executeAction(trackEmailFriend, { itemPk });
        done();
    },
    contactDealer(actionContext, payload, done) {
        // FINDING-7331 This method is for an optimizely variant to make the contact dealer modal
        //              appear from clicking on a cta in the sidebar. Remove this code if the
        //              variant is removed. Alternatively, remove this comment if the variant
        //              becomes permanent.
        // calling "private" property so can be spied on in tests
        modals._dealer(actionContext, payload);
        done();
    },
    netPrice(actionContext, payload, done) {
        modals._netPrice(actionContext, payload);
        done();
    },
    _dealer: launchContactDealer,
    _stf: launchModalEmail,
    _netPrice: launchRequestNetPrice
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/actions/modals.es.js